import { render, staticRenderFns } from "./ScanHistory.vue?vue&type=template&id=98d816c2&scoped=true"
import script from "./ScanHistory.vue?vue&type=script&lang=js"
export * from "./ScanHistory.vue?vue&type=script&lang=js"
import style0 from "./ScanHistory.vue?vue&type=style&index=0&id=98d816c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d816c2",
  null
  
)

export default component.exports